import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../home/components/Footer';

const products = [
  {
    id: 11,
    name: 'Silent Money Hustle – Limited Graphic Tee – Black',
    price: 45.00,
    category: 'T-Shirts',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black'],
    image: 'https://public.readdy.ai/ai/img_res/edited_9677fd3d8be08f55606e3a77ae870157_d385b793.jpg',
    badge: 'Limited',
    description: 'The Silent Money Hustle limited graphic tee in Black. Bold street art design with the Respect My Hustle logo. Move in silence. Let the bag speak.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-graphic-tee?variant=42776857837645',
  },
  {
    id: 12,
    name: 'Silent Money Hustle – Limited Graphic Tee – Beige',
    price: 45.00,
    category: 'T-Shirts',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Beige'],
    image: 'https://public.readdy.ai/ai/img_res/edited_3ce394bf2319c96d8c6b47d670fc7ea8_683ec62a.jpg',
    badge: 'Limited',
    description: 'The Silent Money Hustle limited graphic tee in Beige. Bold street art design with the Respect My Hustle logo. Move in silence. Let the bag speak.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-graphic-tee?variant=42776857837645',
  },
  {
    id: 1,
    name: 'Respect My Hustle Tee – Black',
    price: 40.00,
    category: 'T-Shirts',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'White', 'Crimson Red'],
    image: 'https://public.readdy.ai/ai/img_res/edited_20084bd1a4d155a4e9b089a74c855a8e_0c10a4e2.jpg',
    badge: 'Best Seller',
    description: 'The signature Respect My Hustle tee. Stand Grind. Loud Legacy. Represent the grind every day.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-tee?variant=42776878055501',
  },
  {
    id: 9,
    name: 'Respect My Hustle Tee — Crimson Red',
    price: 40.00,
    category: 'T-Shirts',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'White', 'Crimson Red'],
    image: 'https://public.readdy.ai/ai/img_res/edited_998ae15572a81e2ff499c2d655862ffa_b8af7db9.jpg',
    badge: 'New',
    description: 'The signature Respect My Hustle tee in bold Crimson Red. Stand Grind. Loud Legacy. Represent the grind every day.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-tee?variant=42776878055501',
  },
  {
    id: 10,
    name: 'Respect My Hustle Tee — White',
    price: 40.00,
    category: 'T-Shirts',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'White', 'Crimson Red'],
    image: 'https://public.readdy.ai/ai/img_res/edited_dca5c313700db2b05184c23d68887fa7_e6c395e8.jpg',
    badge: 'New',
    description: 'The signature Respect My Hustle tee in clean White. Silent Grind. Loud Legacy. Represent the grind every day.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-tee?variant=42776878055501',
  },
  {
    id: 13,
    name: 'Respect My Hustle Crop Tee – Black',
    price: 35.00,
    category: 'T-Shirts',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: ['Black', 'White', 'Crimson Red'],
    image: 'https://public.readdy.ai/ai/img_res/edited_d566dab9db8a08107fb5de82ccf9cb0c_3cff7bb5.jpg',
    badge: 'New',
    description: 'The Respect My Hustle Crop Tee in Black. Cropped cut, bold print, all hustle. Built for those who rep the brand every single day.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-crop-tee?variant=42776875794509',
  },
  {
    id: 14,
    name: 'Respect My Hustle Crop Tee – White',
    price: 35.00,
    category: 'T-Shirts',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: ['Black', 'White', 'Crimson Red'],
    image: 'https://public.readdy.ai/ai/img_res/edited_c0e4a61397caefa9289e7d8ecc89f794_3cff7bb5.jpg',
    badge: 'New',
    description: 'The Respect My Hustle Crop Tee in White. Clean look, loud message. Rep the grind in crisp, fresh white.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-crop-tee?variant=42776875794509',
  },
  {
    id: 15,
    name: 'Respect My Hustle Crop Tee – Crimson Red',
    price: 35.00,
    category: 'T-Shirts',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: ['Black', 'White', 'Crimson Red'],
    image: 'https://public.readdy.ai/ai/img_res/edited_bddae81e25a2651b3d5c0dbc6e1ae3c1_3cff7bb5.jpg',
    imagePosition: 'center',
    badge: 'New',
    description: 'The Respect My Hustle Crop Tee in Crimson Red. Bold color, bolder message. Stand out and rep the hustle every day.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-crop-tee?variant=42776875794509',
  },
  {
    id: 16,
    name: 'Respect My Hustle Hoodie – Black',
    price: 60.00,
    category: 'Hoodies',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black'],
    image: 'https://public.readdy.ai/ai/img_res/edited_9f3e64cd05f81972e8aaa67fe5e6cd3d_a1bce4b9.jpg',
    badge: 'New',
    description: 'The Respect My Hustle Hoodie in Black. Heavyweight fleece, embroidered branding, built for those who move different. Stay warm, stay grinding.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-hoodie',
  },
  {
    id: 17,
    name: 'Respect My Hustle Hoodie – Beige',
    price: 60.00,
    category: 'Hoodies',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Beige'],
    image: 'https://public.readdy.ai/ai/img_res/edited_60bda70ab812555e2df885d6406ec2cc_a1bce4b9.jpg',
    badge: 'New',
    description: 'The Respect My Hustle Hoodie in Beige. Heavyweight fleece, embroidered branding, soft neutral tone for those who move with style. Stay warm, stay grinding.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-hoodie',
  },
  {
    id: 18,
    name: 'Respect My Hustle Joggers – Black',
    price: 50.00,
    category: 'Bottoms',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black'],
    image: 'https://public.readdy.ai/ai/img_res/edited_7e9af9194098efec6f20ca144fcd1fc4_72d67bc8.jpg',
    badge: 'New',
    description: 'The Respect My Hustle Joggers in Black. Heavyweight fleece, embroidered branding on the leg, built for those who move with purpose. Match with the hoodie for the full set.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-hoodie',
  },
  {
    id: 19,
    name: 'Respect My Hustle Joggers – Beige',
    price: 50.00,
    category: 'Bottoms',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Beige'],
    image: 'https://public.readdy.ai/ai/img_res/edited_76e7f9f7fec715f4733cd1aa4c92b168_2f71f112.jpg',
    badge: 'New',
    description: 'The Respect My Hustle Joggers in Beige. Heavyweight fleece, gold embroidered branding on the leg, soft neutral tone for those who move with style. Match with the Beige hoodie for the full set.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/respect-my-hustle-hoodie',
  },
  {
    id: 3,
    name: 'MH Signature Camo',
    price: 42.00,
    category: 'Hats',
    sizes: ['One Size'],
    colors: ['Green'],
    image: 'https://storage.readdy-site.link/project_files/0419a85a-66d9-4d60-959e-7d81a240bcf9/482f56c3-45ce-4030-973f-939c9a3cb783_Ghost-Mannequin-b95f6c75-3855-490b-8189-3e8dd6986a34.jpg?v=5b8ec9d43450f7d1f148f704ea084c6f',
    imagePosition: 'center',
    badge: 'New',
    description: 'The MH Signature Camo Snapback. Structured fit, embroidered branding, built for those who rep the brand on every level. One size fits all.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/products/untitled-mar17_22-45',
  },
  {
    id: 5,
    name: 'Drive & Grind Long Sleeve',
    price: 44.99,
    category: 'T-Shirts',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'White'],
    image: 'https://public.readdy.ai/ai/img_res/84e2547b45b8141ba073283436ed9525.jpg',
    badge: '',
    description: 'Long sleeve comfort with bold back print. The hustle never stops.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/',
  },
  {
    id: 7,
    name: 'RMH Dad Hat',
    price: 24.99,
    category: 'Hats',
    sizes: ['One Size'],
    colors: ['Black', 'White', 'Red'],
    image: 'https://readdy.ai/api/search-image?query=Black%20unstructured%20dad%20hat%20with%20small%20embroidered%20red%20initials%20on%20front%2C%20product%20photography%20on%20clean%20white%20background%2C%20professional%20hat%20photography%2C%20front%20view%2C%20minimalist%20style%2C%20soft%20fabric&width=600&height=600&seq=store-dadhat-1&orientation=squarish',
    badge: '',
    description: 'Relaxed fit dad hat with subtle RMH embroidery.',
    shopifyUrl: 'https://everyday-hustle-collective.myshopify.com/',
  },
];

const categories = ['All', 'T-Shirts', 'Hoodies', 'Hats', 'Bottoms'];

export default function StorePage() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedProduct, setSelectedProduct] = useState<typeof products[0] | null>(null);
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedColor, setSelectedColor] = useState('');
  const [cartCount, setCartCount] = useState(0);
  const [addedToCart, setAddedToCart] = useState(false);

  const filtered = selectedCategory === 'All'
    ? products
    : products.filter(p => p.category === selectedCategory);

  const handleAddToCart = () => {
    if (!selectedSize || !selectedColor) return;
    setCartCount(c => c + 1);
    setAddedToCart(true);
    setTimeout(() => setAddedToCart(false), 2000);
  };

  const openProduct = (product: typeof products[0]) => {
    setSelectedProduct(product);
    setSelectedSize('');
    setSelectedColor('');
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />

      {/* Hero Banner */}
      <div
        className="relative pt-16 md:pt-20 h-64 md:h-80 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url('https://readdy.ai/api/search-image?query=Stylish%20streetwear%20apparel%20collection%20flat%20lay%20with%20black%20and%20red%20clothing%20items%2C%20premium%20fabric%20textures%2C%20modern%20urban%20fashion%20photography%2C%20dark%20moody%20background%20with%20dramatic%20lighting%2C%20high%20contrast%20professional%20product%20photography&width=1920&height=600&seq=store-hero-banner&orientation=landscape')`
        }}
      >
        <div className="text-center z-10 px-4">
          <p className="text-red-500 font-semibold text-sm md:text-base tracking-widest uppercase mb-2">Official Merch</p>
          <h1 className="text-4xl md:text-6xl font-bold tracking-wider" style={{ fontFamily: '"Teko", sans-serif' }}>
            THE <span className="text-red-500">STORE</span>
          </h1>
          <p className="text-gray-300 mt-2 text-base md:text-lg">Wear the hustle. Rep the brand.</p>
        </div>
      </div>

      {/* Cart indicator */}
      {cartCount > 0 && (
        <div className="sticky top-16 md:top-20 z-40 bg-red-600 text-white text-center py-2 text-sm font-semibold">
          <i className="ri-shopping-bag-line mr-2"></i>
          {cartCount} item{cartCount > 1 ? 's' : ''} in your bag — Connect Shopify to enable checkout
        </div>
      )}

      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-10 md:py-14">

        {/* Category Filter */}
        <div className="flex flex-wrap gap-2 mb-8 md:mb-10 justify-center">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                selectedCategory === cat
                  ? 'bg-red-600 text-white'
                  : 'bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
          {filtered.map(product => (
            <div
              key={product.id}
              onClick={() => openProduct(product)}
              className="group bg-gray-900 rounded-xl overflow-hidden border border-white/5 hover:border-red-600/40 transition-all duration-300 cursor-pointer hover:-translate-y-1"
            >
              <div className="relative w-full h-48 md:h-56 lg:h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ${'imagePosition' in product && product.imagePosition === 'center' ? 'object-center' : 'object-top'}`}
                />
                {product.badge && (
                  <span className="absolute top-2 left-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full">
                    {product.badge}
                  </span>
                )}
              </div>
              <div className="p-3 md:p-4">
                <p className="text-gray-500 text-xs mb-1">{product.category}</p>
                <h3 className="text-white font-semibold text-sm md:text-base leading-tight mb-2">{product.name}</h3>
                <div className="flex items-center justify-between">
                  <span className="text-red-400 font-bold text-base md:text-lg">${product.price.toFixed(2)}</span>
                  <div className="w-7 h-7 flex items-center justify-center bg-red-600/20 hover:bg-red-600 rounded-full transition-colors">
                    <i className="ri-add-line text-red-400 group-hover:text-white text-sm"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Shopify CTA */}
        <div className="mt-14 md:mt-20 bg-gradient-to-r from-red-900/30 to-black border border-red-600/20 rounded-2xl p-8 md:p-12 text-center">
          <div className="w-14 h-14 flex items-center justify-center bg-red-600/20 rounded-full mx-auto mb-4">
            <i className="ri-store-2-line text-red-400 text-2xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold mb-3" style={{ fontFamily: '"Teko", sans-serif' }}>
            READY TO SELL YOUR MERCH?
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-xl mx-auto mb-6">
            Connect your Shopify store to enable real checkout, inventory management, and order tracking for all your apparel.
          </p>
          <div className="flex flex-wrap gap-4 justify-center text-sm text-gray-400">
            <span className="flex items-center gap-2"><i className="ri-check-line text-red-500"></i> Real-time inventory</span>
            <span className="flex items-center gap-2"><i className="ri-check-line text-red-500"></i> Secure checkout</span>
            <span className="flex items-center gap-2"><i className="ri-check-line text-red-500"></i> Order tracking</span>
            <span className="flex items-center gap-2"><i className="ri-check-line text-red-500"></i> Multiple variants</span>
          </div>
        </div>
      </div>

      <Footer />

      {/* Product Modal */}
      {selectedProduct && (
        <div
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedProduct(null)}
        >
          <div
            className="bg-gray-900 rounded-2xl max-w-2xl w-full overflow-hidden border border-white/10 max-h-[90vh] overflow-y-auto"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex flex-col md:flex-row">
              <div className="w-full md:w-1/2 h-64 md:h-auto">
                <img
                  src={selectedProduct.image}
                  alt={selectedProduct.name}
                  className={`w-full h-full object-cover ${'imagePosition' in selectedProduct && selectedProduct.imagePosition === 'center' ? 'object-center' : 'object-top'}`}
                />
              </div>
              <div className="p-6 md:p-8 flex-1">
                <div className="flex items-start justify-between mb-2">
                  <p className="text-gray-500 text-xs uppercase tracking-widest">{selectedProduct.category}</p>
                  <button
                    onClick={() => setSelectedProduct(null)}
                    className="w-7 h-7 flex items-center justify-center text-gray-400 hover:text-white cursor-pointer"
                  >
                    <i className="ri-close-line text-lg"></i>
                  </button>
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-white mb-1">{selectedProduct.name}</h2>
                <p className="text-red-400 font-bold text-xl mb-4">${selectedProduct.price.toFixed(2)}</p>
                <p className="text-gray-400 text-sm mb-5">{selectedProduct.description}</p>

                {/* Color */}
                <div className="mb-4">
                  <p className="text-gray-300 text-sm font-semibold mb-2">Color</p>
                  <div className="flex flex-wrap gap-2">
                    {selectedProduct.colors.map(color => (
                      <button
                        key={color}
                        onClick={() => setSelectedColor(color)}
                        className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-all cursor-pointer whitespace-nowrap ${
                          selectedColor === color
                            ? 'border-red-500 bg-red-600/20 text-red-400'
                            : 'border-white/20 text-gray-400 hover:border-white/40'
                        }`}
                      >
                        {color}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Size */}
                <div className="mb-6">
                  <p className="text-gray-300 text-sm font-semibold mb-2">Size</p>
                  <div className="flex flex-wrap gap-2">
                    {selectedProduct.sizes.map(size => (
                      <button
                        key={size}
                        onClick={() => setSelectedSize(size)}
                        className={`w-10 h-10 flex items-center justify-center rounded-lg text-xs font-bold border transition-all cursor-pointer ${
                          selectedSize === size
                            ? 'border-red-500 bg-red-600/20 text-red-400'
                            : 'border-white/20 text-gray-400 hover:border-white/40'
                        }`}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                </div>

                <a
                  href={selectedProduct.shopifyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full py-3 rounded-full font-bold text-sm text-center bg-red-600 hover:bg-red-700 text-white transition-all duration-200 whitespace-nowrap cursor-pointer mb-3"
                >
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-external-link-line"></i> View &amp; Buy on Shop
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
